import { render, staticRenderFns } from "./SuppliersHome.vue?vue&type=template&id=39da9970&scoped=true"
import script from "./SuppliersHome.vue?vue&type=script&lang=js"
export * from "./SuppliersHome.vue?vue&type=script&lang=js"
import style0 from "./SuppliersHome.vue?vue&type=style&index=0&id=39da9970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39da9970",
  null
  
)

export default component.exports